import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=70ab1258&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=70ab1258&scoped=true&lang=css&"
import style1 from "./Address.vue?vue&type=style&index=1&id=70ab1258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab1258",
  null
  
)

export default component.exports